import { useNavigate } from "react-router-dom";
import { relativeURL } from "../relativeURL";

export const useLookUp = () => {
  let navigate = useNavigate();
  async function lookup(
    species,
    database,
    nativeId,
    network_type,
    protein_type,
    userColor,
    currentPositions
  ) {
    const resp = await fetch(relativeURL("/api/lookup"), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        species: species,
        database: database,
        nativeId: nativeId,
        network_type: network_type,
        protein_type: protein_type,
        current_positions: currentPositions,
      }),
    });

    const body = await resp.json();
    navigate(`/session/${body.sid}`);
  }

  return {
    lookup,
  };
};
